/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function AutoSize({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path d="M0 0h16v16H0z" /><path fill="currentColor" fillRule="evenodd" d="M14.4 4.4a.6.6 0 1 0 0 1.2.6.6 0 0 0 0-1.2Zm0 3a.6.6 0 1 0 0 1.2.6.6 0 0 0 0-1.2Zm0 3a.6.6 0 1 0 0 1.2.6.6 0 0 0 0-1.2Z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M2.5 2.1a.4.4 0 0 0-.4.4v11c0 .22.18.4.4.4h11.9a.6.6 0 1 1 0 1.2H2.5a1.6 1.6 0 0 1-1.6-1.6v-11A1.6 1.6 0 0 1 2.5.9h11.9a.6.6 0 1 1 0 1.2H2.5ZM4 3.4a.6.6 0 0 1 .6.6v3.4h4.451L7.076 5.424a.6.6 0 0 1 .848-.848l3 3a.6.6 0 0 1 0 .848l-3 3a.6.6 0 0 1-.848-.848L9.05 8.6H4.6V12a.6.6 0 1 1-1.2 0V4a.6.6 0 0 1 .6-.6Z" clipRule="evenodd" /></svg>;
}
;